import type { TDatadogErrorLog } from 'utils/datadog/types'

export const GET_HUBSPOT_VISITOR_IDENTIFICATION_LOG: TDatadogErrorLog = {
  from: 'src/hooks/use-customer-agent-identity/index.ts',
  name: 'Get HubSpot Visitor Identification',
  message: 'Failed to fetch the HubSpot visitor identification token',
}
